import { EventEmitter, Injectable, signal, SimpleChanges, WritableSignal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAbstractPresenter, IconName, ILanguageObject } from '@core/interfaces';
import { IButtonComponent, IButtonPresenter } from './interfaces';
import { ButtonTypeEnum, ButtonTypeEnumValues } from './enums';

@Injectable({ providedIn: 'root' })
export class ButtonPresenter extends IAbstractPresenter<IButtonComponent> implements IButtonPresenter {
	loading$: Observable<boolean> = of(false);
	translations: ILanguageObject = {};

	disabled: boolean = false;
	icon: IconName | null = null;
	text: string | null = null;
	type: ButtonTypeEnumValues = ButtonTypeEnum.PRIMARY;
	buttonClassSignal: WritableSignal<string> = signal<string>(ButtonTypeEnum.PRIMARY);

	buttonClicked: EventEmitter<void> = new EventEmitter<void>();

	constructor() {
		super();
	}

	override onChanges(changes: SimpleChanges): void {
		if (changes)
			if (changes?.['type'])
				this.buttonClassSignal.set(changes?.['type']?.['currentValue']);
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	onClick(): void {
		this.view.buttonClicked.emit();
	}
}
